import type { Guide } from "#public"

/**
 * `flipped` holds the guide ids toggled away from their own default
 * (`guide.active`: destinations start shown, the marks guide starts hidden) —
 * an empty list means "every guide at its default", not "show everything".
 * Drives `active_guides` (what the imposition facade actually renders) — the
 * marks guide being "visible" here means the page switches to printable
 * mode, not that helper overlays are drawn (see {@link GuidePressed}).
 */
export const GuideVisible = (guide: Guide, flipped: string[]): boolean =>
  flipped.includes(guide.id) ? !guide.active : guide.active

/**
 * Whether a guide's toggle button should read as "on". Matches
 * {@link GuideVisible} for destinations (pressed = this print layer is
 * showing). Inverted for the marks guide: making it active switches
 * rendering to printable/export mode, which *hides* the preview overlays
 * (safety margin, cut lines, ...) it's meant to control — so the button
 * looks "on" exactly while those overlays are visible, i.e. while marks is
 * NOT active. Mirrors the original filecheck.tsx, which only struck out its
 * marks toggle while `this.marks` was true.
 */
export const GuidePressed = (guide: Guide, flipped: string[]): boolean =>
  guide.kind === "marks" ? !GuideVisible(guide, flipped) : GuideVisible(guide, flipped)
